import { ExportTasksExcelData } from '../interfaces/export-tasks-excel-data.interface';

export interface ExportTasksSectionExcelData {
    id: string;
    name: string;
    tasks: ExportTasksExcelData[];
}
